import React, { createContext, useContext, useState, ReactNode, useRef, RefObject } from 'react';

interface InfiniteScrollContextType {
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  isScrollLoading: boolean;
  setIsScrollLoading: React.Dispatch<React.SetStateAction<boolean>>;
  lastPage: number;
  setLastPage: React.Dispatch<React.SetStateAction<number>>;
  contentRef: RefObject<HTMLDivElement>;
}

const InfiniteScrollContext = createContext<InfiniteScrollContextType>({
  page: 1,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setPage: () => {},
  isScrollLoading: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setIsScrollLoading: () => {},
  lastPage: 1,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setLastPage: () => {},
  contentRef: React.createRef<HTMLDivElement>(),
});

// eslint-disable-next-line react-refresh/only-export-components
export const useInfiniteScroll = () => useContext(InfiniteScrollContext);

interface InfiniteScrollProviderProps {
  children: ReactNode;
}

export const InfiniteScrollProvider: React.FC<InfiniteScrollProviderProps> = ({ children }) => {
  const [page, setPage] = useState(1);
  const [isScrollLoading, setIsScrollLoading] = useState(false);
  const [lastPage, setLastPage] = useState(1);
  const contentRef = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  // }, [lastPage])

  return (
    <InfiniteScrollContext.Provider
      value={{
        page,
        setPage,
        isScrollLoading,
        setIsScrollLoading,
        lastPage,
        setLastPage,
        contentRef,
      }}
    >
      {children}
    </InfiniteScrollContext.Provider>
  );
};
